import { createFileRoute } from '@tanstack/react-router';
import { Clock } from 'lucide-react';

import { SurveyStatusContent } from '../@components/StatusContent';

export const Route = createFileRoute(
  '/_layout/$lang/quality-survey/_layout/expired',
)({
  component: Expired,
});

function Expired() {
  console.log(
    'encodedToken',
    btoa(
      JSON.stringify({
        exp: 1779946196,
        id: '019e0784-7f49-7cd7-a559-bc521bb2e3e8',
        parentId: '019cbe75-7b46-7077-9147-c058b235a9b7',
        parentStatus: 'lost',
        type: 'intervention',
        providerName: 'Nu-Isoleren.be',
        source: 'connect',
      }),
    ),
  );
  return (
    <SurveyStatusContent
      icon={Clock}
      iconBgClassName="bg-amber-50"
      iconClassName="text-amber-500"
      messageKey="survey.expired.message"
      titleKey="survey.expired.title"
    />
  );
}
